<template>
  <section>
    <BTabs id="pipeline-tabs" active>
      <SalesFunnelStages @click="handleTabChange" :can="can" />
      <SalesFunnelOtherSettings @click="handleTabChange" />
    </BTabs>
  </section>
</template>

<script>
import { BTabs } from 'bootstrap-vue';
import SalesFunnelStages from './pipeline/tabs/SalesFunnelStages.vue';
import SalesFunnelOtherSettings from './pipeline/tabs/SalesFunnelOtherSettings.vue';

export default {
  components: {
    BTabs,
    SalesFunnelStages,
    SalesFunnelOtherSettings,
  },

  props: ['can'],

  data() {
    return {
      pipeline: '',
    };
  },

  methods: {
    handleTabChange(tabIndex) {
      console.log({tabIndex});
      // Bus.$emit('tab-changed', tabIndex);
      if (tabIndex === 0) {
        document.getElementById('pipeline-counter').style.backgroundColor = '#8869FD';
      } else {
        document.getElementById('pipeline-counter').style.backgroundColor = '#858585';
      }
      // this.activeTab = tabIndex;
    },
  },

  mounted() {
    Bus.$on('tab-changed', (tabIndex) => {
      this.handleTabChange(tabIndex);
    });
  },
};
</script>

<style scoped ::v-deep>
::v-deep #pipeline-tabs .nav-link {
  padding-left: 4px !important;
}

::v-deep #pipeline-tabs .nav-link {
  margin-right: 16px !important;
  padding: 0 !important;
  line-height: 18px !important;
  font-size: 14px !important;
  font-family: 'Montserrat' !important;
  font-weight: 600 !important;
}

::v-deep #pipeline-tabs .nav-link.active {
  padding-bottom: 7px !important;
  border-radius: 0 !important;
  line-height: 18px !important;
  color: #242424 !important;
  font-size: 14px !important;
  font-family: 'Montserrat' !important;
  font-weight: 600 !important;
  border-bottom: 2px solid #8869FD !important;
}

::v-deep #pipeline-tabs .nav-tabs {
  background: white;
}

::v-deep #pipeline-tabs .tab-content {
  padding-left: 0 !important;
  padding-right: 0 !important;
  padding-top: 16px !important;
}
</style>
